/**
 * Generated by orval v8.20.0 🍺
 * Do not edit manually.
 * Iaso
 * Iaso Swagger
 * OpenAPI spec version: v1
 */
import { z as zod } from 'zod';

export const ApiAccountsAiApiKeyDestroyParams = zod.strictObject({
    format: zod.enum(['csv', 'json']).optional(),
});

export type ApiAccountsAiApiKeyDestroyParams = zod.input<
    typeof ApiAccountsAiApiKeyDestroyParams
>;
export type ApiAccountsAiApiKeyDestroyParamsOutput = zod.output<
    typeof ApiAccountsAiApiKeyDestroyParams
>;
